/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createLOG10E } from '../../factoriesAny.js';
export var LOG10EDependencies = {
  BigNumberDependencies,
  createLOG10E
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesLOG10E.generated.js
// module id = E98h
// module chunks = 3